export const priceSymbol = '$';